import ListingBody from '../../../../../../components/Listing/ListingBody/ListingBody';
export default ListingBody;
